export let template = {
	wedCafeCount: 0,
	worksSummary: function(data){
		let eyecatch = getImg(data.eyecatch, data.title);
		//console.log(eyecatch)
		let categories = ``;
		//console.log(data.categories);
		if(data.categories){
			categories += `<div class="c-categorylist_works"><ul>`
			for( let i = 0; i < data.categories.length; i++){
				categories += `<li><span>${data.categories[i].name}</span></li>`
			}
		
			categories += `</ul></div>`;
		}
		return  `<li class="c-summary">
					<a href="/works/${data.slug}/" data-link>
						<div class="c-works_summary">
							<div class="inner">
								<figure>
									${eyecatch}
								</figure>
								<hgroup>
									<h3>${data.title}</h3>
									<p>${data.title_en}</p>
								</hgroup>
								${categories}
							</div>
						</div>
					</a>
				</li>`;
			
		function getImg(eyecatch, title){
			if( !eyecatch ){
				return "";
			}else{
				return `<img src="${eyecatch.url_sp}" width="${eyecatch.width_sp}" height="${eyecatch.height_sp}" alt="${title}">`;
			}
		}
	},
	magazineSummary: function(data, tag, indexNum){
		//console.log("tag:", tag);
		//console.log(indexNum)
		if( tag === "wednesday_kitchen" ){
			let menu = "";
			//console.log(data, tag);
			for(let i = 0; i < data.menu.length; i++){
				menu += `<li><span>${data.menu[i]}</span></li>`
			}
			/* 2025.03.31
			<div class="c-ttl_wedcafe">
				<h3><img src="/assets/images/common/wednesday_cafe.webp" alt="水曜食堂" width="390" height="390" /></h3>
			</div>
			<div class="">
				<h4>${data.date}の献立</h4>
				<ul>
					${menu}
				</ul>
			</div>
			*/
			let eyecatch = data.eyecatch;
			let categories = ``;
			let isWedCafe = false;
			if( data.categories ){
				for(let i = 0; i < data.categories.length; i++){
					categories += `<li><span>#${data.categories[i].name}</span></li>`;
				}
			}
			if( data.tags ){
				for(let j = 0; j < data.tags.length; j++){
					categories += `<li><span>#${data.tags[j].name}</span></li>`
				}
			}
			let $picture = `<picture>
								<source type="image/webp" media="(max-width: 947px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
								<source type="image/webp" media="(min-width: 948px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
								<img src="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}" alt="${data.title}">
							</picture>`;
			if( indexNum > 12 ){
				$picture = `<picture>
								<source type="image/webp" media="(max-width: 947px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
								<source type="image/webp" media="(min-width: 948px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
								<img src="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}" alt="${data.title}" loading="lazy">
							</picture>`;
			}
			//水曜食堂で画像がなかった場合
			if( eyecatch.length === 0 ){
				$picture = `<img src="/assets/images/magazine/wedcafe/no-image${template.wedCafeCount}.webp" alt="水曜食堂" width="390" height="390" />`;
				template.wedCafeCount++;
				if( template.wedCafeCount >= 5 ){
					template.wedCafeCount = 0;
				}
			}
			let temp = "";
			temp = `<li class="c-summary disable" data-summary>
						<a href="/magazine/${data.slug}/" data-link="wedcafe">
							<figure class="c-thumbnail">
								${$picture}
							</figure>
							<div class="c-col2">
								<div class="c-col2_l">
									<figure class="c-img_profile">
										<img src="https://www.spoon-inc.co.jp/cms/wp-content/uploads/2024/11/水曜食堂_2行組_スプーンあり-320x320.png" width="50" height="50" alt="水曜食堂">
									</figure>
								</div>
								<div class="c-col2_r">
									<hgroup>
										<h3>${data.title}</h3>
										<p>${ getExcerpt(data.caption) }</p>
									</hgroup>
									<div class="c-categorylist_magazine">
										<ul>
											${categories}
										</ul>
									</div>
								</div>
							</div>
							
						</a>
					</li>`;
			return temp;
		}else{
			let eyecatch 		= data.eyecatch;
			let profile 		= data.author;
			let imgProfile = "";
			if(profile.eyecatch){
				let imgProfileSrc 	= profile.eyecatch.url_sp;
				imgProfile 	=	`<div class="c-col2_l">
									<figure class="c-img_profile">
										<img src="${imgProfileSrc}" width="50" height="50" alt="${profile.name}">
									</figure>
								</div>`;
			}
			//console.log(profile)
			if( profile.status === "private" ){
				imgProfile = "";
			}
			let categories = ``;
			if( data.categories ){
				for(let i = 0; i < data.categories.length; i++){
					categories += `<li><span>#${data.categories[i].name}</span></li>`
				}
			}
			if( data.tags ){
				for(let j = 0; j < data.tags.length; j++){
					categories += `<li><span>#${data.tags[j].name}</span></li>`
				}
			}
			let img = `<picture>
						<source type="image/webp" media="(max-width: 947px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
						<source type="image/webp" media="(min-width: 948px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
						<img src="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}" alt="${data.title}">
					</picture>`;
			if( indexNum > 12 ){
				img = `<picture>
							<source type="image/webp" media="(max-width: 947px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
							<source type="image/webp" media="(min-width: 948px)" srcset="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}">
							<img src="${eyecatch.url_pc}" width="${eyecatch.width_pc}" height="${eyecatch.height_pc}" alt="${data.title}" loading="lazy">
						</picture>`;
			}
			return `<li class="c-summary disable" data-summary>
						<a href="/magazine/${data.slug}/" data-link>
							<figure class="c-thumbnail">
								${img}
							</figure>
							<div class="c-col2">
								${imgProfile}
								<div class="c-col2_r">
									<hgroup>
										<h3>${data.title}</h3>
										<p>${ getExcerpt(data.caption) }</p>
									</hgroup>
									<div class="c-categorylist_magazine">
										<ul>
											${categories}
										</ul>
									</div>
								</div>
							</div>
						</a>
					</li>`;
		}
	},
	wedCafe: function(data, hasButtonType){
		let d = data[0];
		//console.log(d, data);
		let menuHTML = "";
		for(let i = 0; i < d.menu.length; i++){
			menuHTML += `<li><span>${d.menu[i]}</span></li>`;
		}
		let btn = ``;
		if( hasButtonType === 1 ){
			btn = `<div class="c-wrap_btn">
						<a href="/magazine/?tag=wednesday_kitchen" class="c-btn bdr round4 h40" data-link>
							<span>すべての献立を見る</span>
						</a>
					</div>`;
		}
		if( hasButtonType === 2 ){
			btn = `<div class="c-wrap_btn">
						<a href="/magazine/magazine64/" class="c-btn bdr round4 h40" data-link>
							<span>水曜食堂とは？</span>
						</a>
					</div>`;
		}
		return `<li class="c-wedcafe disable" data-summary>
					<div class="c-wedcafe_inner">
						<div class="c-ttl_wedcafe">
							<h3><img src="/assets/images/common/wednesday_cafe.webp" alt="水曜食堂" width="390" height="390" /></h3>
						</div>
						<div class="">
							<h4>${d.date}の献立</h4>
							<ul>
								${menuHTML}
							</ul>
							${btn}
						</div>
					</div>
				</li>`;
		///magazine/?tag=wednesday_kitchen
		//<span>すべての献立を見る</span>
	},
	newsSummary: function(data){
		//console.log(data);
		return  `<li class="c-summary">
					<a href="/news/${data.slug}/" data-link>
						<div class="c-col2">
							<div class="c-col2_l">
								<figure>
									<img src="${data.eyecatch.url_sp}" alt="${data.title}" width="60" height="60">
								</figure>
							</div>
							<div class="c-col2_r">
								<h3>${data.title}</h3>
								<p>${data.publish_date}</p>
							</div>
						</div>
					</a>
				</li>`;
	}
}
let getExcerpt = (text) => {
	let t = ""
	if(text){
		let thisText = text.replace(/<\/?[^>]+(>|$)/g, "");
		let len = thisText.length;
		
		if( len > 44){
			t = thisText.slice(0, 44) + "…";
		}else{
			t = thisText.slice(0, 44);
		}
	}
	
	return t
}